import React from "react";
import styled from "styled-components";

interface CoverProps {
  cover: string | null;
  height: string;
  width: string;
}

export const Cover: React.FC<CoverProps> = props => {
  return (
    <Container cover={props.cover} height={props.height} width={props.width} />
  );
};

const Container = styled.div<{
  cover: string | null;
  height: string;
  width: string;
}>`
  height: ${props => props.height};
  width: ${props => props.width};
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-color: ${props => props.cover ? 'transparent' : '#E9E9E9'};
  background-image: url("${props => props.cover}");
`;
